"use client";

import { Instagram, Phone } from "lucide-react";
import Logo from "../Logo";
import Image from "next/image";
import Whatsapp from "@/public/icon/whatsapp.svg";
import Link from "next/link";
import moment from "moment-jalaali";

export default function Footer() {
  const currentYear = moment().format('jYYYY');

  return (
    <footer className="flex min-h-[280px] w-full items-center justify-center bg-black/70 py-10 text-white mt-10 sm:min-h-[320px] lg:mt-20 lg:py-16">
      <div className="container mx-auto space-y-8 px-4 sm:space-y-10">
        
        <div className="flex justify-center">
           <Logo width={120} /> 
        </div>

        <nav className="flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm text-gray-300 md:gap-10 md:text-base">
          <Link href="/about-us" className="hover:text-white transition-colors">درباره ما</Link>
          <Link href="/stores" className="hover:text-white transition-colors">فروشگاه‌های ما</Link>
          <Link href="/product" className="hover:text-white transition-colors">محصولات ما</Link>
        </nav>

        <div className="flex justify-center items-center gap-8">
          <Link href="tel:+989192387002" className="hover:text-sky-500 transition-colors" aria-label="تلگرام">
            <Phone size={20} className="stroke-[1.5px]" />
          </Link>
          <Link target="_blank" href="https://instagram.com/smart.lifehome" className="hover:text-pink-500 transition-colors" aria-label="اینستاگرام">
            <Instagram size={22} className="stroke-[1.5px]" />
          </Link>
          <Link target="_blank" href="https://wa.me/989192387002" className="hover:opacity-80 transition-opacity" aria-label="واتساپ">
            <Image src={Whatsapp} alt="واتساپ اسمارت  " width={22} height={22} />
          </Link>
        </div>

        <div className="w-full border-b border-white/10"></div>

        <div className="text-gray-500 text-center text-xs md:text-sm dir-rtl">
          تمامی حقوق متعلق به <Link href={"https://ksaya.net/"} target="_blank"> شرکت کاوش هوشمند سایا</Link> است
          © {currentYear} 
        </div>
        
      </div>
    </footer>
  );
}